<div [formGroup]="form">
<div class="section-container">
    <div class="section-title">
        <mat-icon class="material-symbols-outlined">rule</mat-icon>
        <span>{{ modoExcecao ? 'Regra de Exceção' : 'Regra Padrão' }}</span>
        <div class="section-title-actions ms-auto">
            <span class="personalizar-tooltip-wrap"
                [matTooltip]="personalizarTooltip"
                [matTooltipDisabled]="!personalizarBloqueado">
                <button mat-button type="button" class="btn-section"
                    [matBadge]="personalizadasCount" [matBadgeHidden]="personalizadasCount === 0"
                    [disabled]="personalizarBloqueado"
                    (click)="onPersonalizar()">
                    <mat-icon class="material-symbols-outlined">settings</mat-icon>
                    Personalizar fórmulas
                </button>
            </span>
        </div>
    </div>

    <div class="row g-3">

        <!-- CST -->
        <div class="col-12 col-md-8">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>{{ modoExcecao ? 'CST da exceção' : 'CST ICMS' }}</mat-label>
                <mat-select formControlName="cstIcms">
                    <mat-option [value]="null">— Selecione —</mat-option>
                    @for (c of codigoTributosDaOperacao; track c.codigo) {
                    <mat-option [value]="c.codigo">{{ c.codigo }} – {{ c.descricao }}</mat-option>
                    }
                </mat-select>
                @if (form.get('cstIcms')?.hasError('required') && form.get('cstIcms')?.touched) {
                <mat-error>CST é obrigatório.</mat-error>
                }
            </mat-form-field>
        </div>

        <!-- CFOP -->
        <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>CFOP</mat-label>
                <input matInput type="text" inputmode="numeric"
                    [formControl]="cfopControl"
                    [mask]="masks.cfop" [patterns]="cfopPatterns"
                    [placeholder]="cfopPlaceholder"
                    (keydown)="onCfopKeydown($event)">
                <button mat-icon-button matSuffix type="button"
                    matTooltip="Pesquisar CFOP"
                    (click)="pesquisarCfop()">
                    <mat-icon>search</mat-icon>
                </button>
                <mat-icon
                    matSuffix
                    [matTooltip]="cfopTooltipInfo"
                    matTooltipClass="cfop-tooltip"
                    matTooltipPosition="above">
                    info_outline
                </mat-icon>
                @if (cfopControl?.hasError('cfopTipoInvalido') && cfopControl?.touched) {
                <mat-error>CFOP inválido para o tipo de operação selecionado.</mat-error>
                }
            </mat-form-field>
        </div>

        <!-- Alert CST meta -->
        @if (cstIcmsTexto) {
        <div class="col-12">
            <app-alert-card [type]="cstIcmsTexto.alertaTipo" [title]="cstIcmsTexto.alertaTitulo">
                {{ cstIcmsTexto.alertaTexto }}
            </app-alert-card>
        </div>
        }

        <!-- Benefícios fiscais: sempre visível, livre e opcional para qualquer CST -->
        <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Código do Benefício Fiscal (cBenef)</mat-label>
                <input matInput type="text" formControlName="codigoBeneficioFiscal" placeholder="Ex: SP012345"
                    matTooltip="Verifique a compatibilidade com a UF, o CST e a legislação vigente.">
            </mat-form-field>
        </div>

        <!-- Redução da alíquota ad rem (CST 15) -->
        @if (algumAtivo(['pRedAdRem', 'motRedAdRem'])) {
        <div class="col-12">
            <div class="sub-section-container">
                <div class="sub-section-title">
                    <mat-icon>percent</mat-icon>
                    <span>Redução da Alíquota Ad Rem</span>
                </div>
                <div class="row g-3 mt-1">
                    @if (ativo('pRedAdRem')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Redução da Alíquota Ad Rem (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pRedAdRem">
                            @if (form.get('pRedAdRem')?.hasError('required') && form.get('pRedAdRem')?.touched) {
                            <mat-error>Redução da alíquota ad rem é obrigatória.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                    @if (ativo('motRedAdRem')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Motivo da Redução</mat-label>
                            <mat-select formControlName="motRedAdRem">
                                <mat-option [value]="null">— Selecione —</mat-option>
                                @for (m of motivosReducaoAdRem; track m.codigo) {
                                <mat-option [value]="m.codigo">{{ m.codigo }} – {{ m.descricao }}</mat-option>
                                }
                            </mat-select>
                            @if (form.get('motRedAdRem')?.hasError('required') && form.get('motRedAdRem')?.touched) {
                            <mat-error>Motivo da redução é obrigatório quando houver redução da alíquota ad rem.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                </div>
            </div>
        </div>
        }

        <!-- Modalidade BC -->
        @if (ativo('modBC')) {
        <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Modalidade da BC do ICMS</mat-label>
                <mat-select formControlName="modalidadeBc">
                    <mat-option [value]="null">— Selecione —</mat-option>
                    @for (m of modalidadesBc; track m.valor) {
                    <mat-option [value]="m.valor">{{ m.descricao }}</mat-option>
                    }
                </mat-select>
                @if (form.get('modalidadeBc')?.hasError('required') && form.get('modalidadeBc')?.touched) {
                <mat-error>Modalidade da BC é obrigatória.</mat-error>
                }
            </mat-form-field>
        </div>
        }

        <!-- Redução BC -->
        @if (ativo('pRedBC')) {
        <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Redução da Base de Cálculo (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pRedBc">
                @if (form.get('pRedBc')?.hasError('required') && form.get('pRedBc')?.touched) {
                <mat-error>Redução da base de cálculo é obrigatória.</mat-error>
                }
            </mat-form-field>
        </div>
        }

        <!-- Alíquota ICMS -->
        @if (ativo('pICMS')) {
        <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Alíquota ICMS (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pIcms">
                @if (form.get('pIcms')?.hasError('required') && form.get('pIcms')?.touched) {
                <mat-error>Alíquota do ICMS é obrigatória.</mat-error>
                }
            </mat-form-field>
        </div>
        }

        <!-- FCP -->
        @if (ativo('pFCP')) {
        <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>FCP (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pFcp">
                @if (form.get('pFcp')?.hasError('required') && form.get('pFcp')?.touched) {
                <mat-error>FCP é obrigatório.</mat-error>
                }
            </mat-form-field>
        </div>
        }

        <!-- DIFAL: independente do CST — nasce da operação, não do código de tributação -->
        <div class="col-12 col-md-4 d-flex align-items-center">
            <mat-slide-toggle class="app-toggle-compact" formControlName="isDifalHabilitado">
                {{ difalLabel }}
            </mat-slide-toggle>
        </div>

        <!-- Substituição Tributária (ST) -->
        @if (algumAtivo(['modBCST', 'pMVAST', 'pRedBCST', 'pICMSST', 'pFCPST'])) {
        <div class="col-12">
            <div class="sub-section-container">
                <div class="sub-section-title">
                    <mat-icon>swap_horiz</mat-icon>
                    <span>Substituição Tributária (ICMS-ST)</span>
                </div>
                <div class="row g-3 mt-1">
                    @if (ativo('modBCST')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Modalidade de BC da ST</mat-label>
                            <mat-select formControlName="modalidadeBcSt">
                                <mat-option [value]="null">— Selecione —</mat-option>
                                @for (m of modalidadesBcSt; track m.valor) {
                                <mat-option [value]="m.valor">{{ m.descricao }}</mat-option>
                                }
                            </mat-select>
                            @if (form.get('modalidadeBcSt')?.hasError('required') && form.get('modalidadeBcSt')?.touched) {
                            <mat-error>Modalidade da BC do ST é obrigatória.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                    @if (ativo('pMVAST')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>MVA Ajustado (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pMvaSt">
                            @if (form.get('pMvaSt')?.hasError('required') && form.get('pMvaSt')?.touched) {
                            <mat-error>MVA ajustado é obrigatório.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                    @if (ativo('pRedBCST')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Redução da Base de Cálculo ST (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pRedBcSt">
                            @if (form.get('pRedBcSt')?.hasError('required') && form.get('pRedBcSt')?.touched) {
                            <mat-error>Redução da base de cálculo ST é obrigatória.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                    @if (ativo('pICMSST')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Alíquota ICMS-ST (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pIcmsSt">
                            @if (form.get('pIcmsSt')?.hasError('required') && form.get('pIcmsSt')?.touched) {
                            <mat-error>Alíquota do ICMS ST é obrigatória.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                    @if (ativo('pFCPST')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>FCP retido por ST (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pFcpSt">
                            @if (form.get('pFcpSt')?.hasError('required') && form.get('pFcpSt')?.touched) {
                            <mat-error>FCP retido por ST é obrigatório.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                </div>
            </div>
        </div>
        }

        <!-- Diferimento -->
        @if (algumAtivo(['pDif', 'pFCPDif', 'cBenefRBC'])) {
        <div class="col-12">
            <div class="sub-section-container">
                <div class="sub-section-title">
                    <mat-icon>pause_circle</mat-icon>
                    <span>Diferimento</span>
                </div>
                <div class="row g-3 mt-1">
                    @if (ativo('pDif')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Diferimento (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pDif">
                            @if (form.get('pDif')?.hasError('required') && form.get('pDif')?.touched) {
                            <mat-error>Percentual de diferimento é obrigatório.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                    @if (ativo('pFCPDif')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>FCP do Diferimento (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pFcpDif">
                            @if (form.get('pFcpDif')?.hasError('required') && form.get('pFcpDif')?.touched) {
                            <mat-error>FCP do diferimento é obrigatório.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                    @if (ativo('cBenefRBC')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Código do Benefício RBC</mat-label>
                            <input matInput type="text" formControlName="codigoBeneficioRbc" placeholder="Ex: SP012345">
                            @if (form.get('codigoBeneficioRbc')?.hasError('required') && form.get('codigoBeneficioRbc')?.touched) {
                            <mat-error>Código do benefício RBC é obrigatório.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                </div>
            </div>
        </div>
        }

        <!-- Motivo de Desoneração do ICMS -->
        @if (ativo('motDesICMS')) {
        <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Motivo Desoneração ICMS</mat-label>
                <mat-select formControlName="motDesIcms">
                    <mat-option [value]="null">— Selecione —</mat-option>
                    @for (m of motivosDesoneracao; track m.codigo) {
                    <mat-option [value]="m.codigo">{{ m.codigo }} – {{ m.descricao }}</mat-option>
                    }
                </mat-select>
                @if (avisoMotivoDesoneracaoForaSugerido) {
                <mat-hint>Motivo incomum para este CST. Verifique se está correto conforme a legislação da UF.</mat-hint>
                }
                @if (form.get('motDesIcms')?.hasError('required') && form.get('motDesIcms')?.touched) {
                <mat-error>Motivo da desoneração do ICMS é obrigatório.</mat-error>
                }
            </mat-form-field>
        </div>
        }

        <!-- Desoneração do ICMS-ST -->
        @if (ativo('motDesICMSST')) {
        <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Motivo Desoneração ICMS-ST</mat-label>
                <mat-select formControlName="motDesIcmsSt">
                    <mat-option [value]="null">— Selecione —</mat-option>
                    @for (m of motivosDesoneracao; track m.codigo) {
                    <mat-option [value]="m.codigo">{{ m.codigo }} – {{ m.descricao }}</mat-option>
                    }
                </mat-select>
                @if (avisoMotivoDesoneracaoStForaSugerido) {
                <mat-hint>Motivo incomum para este CST. Verifique se está correto conforme a legislação da UF.</mat-hint>
                }
                @if (form.get('motDesIcmsSt')?.hasError('required') && form.get('motDesIcmsSt')?.touched) {
                <mat-error>Motivo da desoneração do ICMS-ST é obrigatório.</mat-error>
                }
            </mat-form-field>
        </div>
        }

        <!-- ST Cobrada Anteriormente -->
        @if (algumAtivo(['pST', 'pFCPSTRet', 'obterStCompra'])) {
        <div class="col-12">
            <div class="sub-section-container">
                <div class="sub-section-title">
                    <mat-icon>receipt</mat-icon>
                    <span>ST Cobrada Anteriormente</span>
                </div>
                <div class="row g-3 mt-1">
                    @if (ativo('pST')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Alíquota suportada pelo consumidor (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pSt">
                            @if (form.get('pSt')?.hasError('required') && form.get('pSt')?.touched) {
                            <mat-error>Alíquota suportada pelo consumidor é obrigatória.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                    @if (ativo('pFCPSTRet')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>FCP ST Retido (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pFcpStRet">
                            @if (form.get('pFcpStRet')?.hasError('required') && form.get('pFcpStRet')?.touched) {
                            <mat-error>FCP ST retido é obrigatório.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                    @if (ativo('obterStCompra')) {
                    <div class="col-12 col-md-4 d-flex align-items-center">
                        <mat-slide-toggle class="app-toggle-compact" formControlName="obterIcmsStCompra">
                            Obter ICMS-ST da nota de compra
                        </mat-slide-toggle>
                    </div>
                    }
                </div>
            </div>
        </div>
        }

        <!-- ICMS Efetivo (B2C) -->
        @if (algumAtivo(['pRedBCEfet', 'pICMSEfet'])) {
        <div class="col-12">
            <div class="sub-section-container">
                <div class="sub-section-title">
                    <mat-icon>storefront</mat-icon>
                    <span>ICMS Efetivo (B2C)</span>
                </div>
                <div class="row g-3 mt-1">
                    @if (ativo('pRedBCEfet')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Redução da Base de Cálculo Efetiva (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pRedBcEfet">
                            @if (form.get('pRedBcEfet')?.hasError('required') && form.get('pRedBcEfet')?.touched) {
                            <mat-error>Percentual de redução BC efetiva é obrigatório.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                    @if (ativo('pICMSEfet')) {
                    <div class="col-12 col-md-4">
                        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                            <mat-label>Alíquota efetiva ICMS (%)</mat-label>
                            <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pIcmsEfet">
                            @if (form.get('pIcmsEfet')?.hasError('required') && form.get('pIcmsEfet')?.touched) {
                            <mat-error>Alíquota do ICMS efetivo é obrigatória.</mat-error>
                            }
                        </mat-form-field>
                    </div>
                    }
                </div>
            </div>
        </div>
        }

    </div>
</div>
</div>
